export { default } from './VideoBoxWithText';



// WEBPACK FOOTER //
// ./src/components/templates/VideoBoxWithText/index.js